import { render, staticRenderFns } from "./JcdcRadioInput.vue?vue&type=template&id=2015d26a"
import script from "./JcdcRadioInput.vue?vue&type=script&lang=ts"
export * from "./JcdcRadioInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports